import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { IAllStates } from '../store/rootReducer';
import AuthLayout from './AuthLayout';

interface IProtectProps {
    children: JSX.Element;
}

export const ProtectedRoute = ({ children }: IProtectProps) => {
    const { isAuthorized, isVerified } = useSelector(
        (state: IAllStates) => ({
            isAuthorized: !!state.auth.user,
            isVerified: state.auth.isVerified,
        }),
        shallowEqual
    );

    if (!isAuthorized || !isVerified) {
        return <AuthLayout />;
    }

    return children;
};
